import { useEffect, useRef } from "react";
import ReportViewer from "../../../../../../../../components/ReportViewer";
import { getFormattedId } from "../../../../../../../../utils/utils";
import OrderTemplate from "./OrderTemplate";
import useSelectedPatient from "../../../../../../../../hooks/local-storage/use-selected-patient";
import { useGetPatientOrderById } from "../../../../../../../../queries/patient-chart/order/use-get-patient-order-by-id";
import { DisclosureHost } from "../../../../../../../../hooks/use-disclosure";
import { formatDateTime } from "../../../../../../../../utils/date-time-utility";
import { GENDER_RECORD } from "../../../../../../../../constants";

// Helper functions for data transformation
const getFirstStringValue = (obj: any) =>
  typeof Object.values(obj || {})[0] === "string"
    ? Object.values(obj)[0]
    : null;
const filterStrings = (obj: any) =>
  obj
    ? Object.values(obj).filter((val): val is string => typeof val === "string")
    : [];

const PrintOrders = ({
  disclosureHost,
}: {
  disclosureHost: DisclosureHost;
}) => {
  const pdfRef = useRef<{ generatePdf: () => void }>(null);
  const [patientData] = useSelectedPatient();

  const { data: orderDataById, isLoading: isLoadingOrderData } =
    useGetPatientOrderById({
      patientOrderId: disclosureHost?.data ?? "",
    });

  const orderData = orderDataById?.data;

  // Transform API response data
  const transformedOrderData = orderData
    ? (() => {
        const row = orderData as any;
        const labTests = filterStrings(row?.tests);
        const icdCodes = filterStrings(row?.medicalCodes);

        return {
          ...row,
          patientName: getFirstStringValue(row?.patient) || "-",
          patientId: row?.patient
            ? getFormattedId(Object.keys(row.patient)[0])
            : "-",
          labReferenceId: row?.uuid ? getFormattedId(row.uuid) : "-",
          providerId: row?.orderingProvider
            ? getFormattedId(Object.keys(row.orderingProvider)[0])
            : "-",
          orderingProviderName:
            getFirstStringValue(row?.orderingProvider) || row?.userName || "-",
          labTests,
          labTestsDisplay: labTests.join(", ") || "-",
          icdCodes,
          icdCodesDisplay: icdCodes.join(", ") || "-",
          birthDate: patientData?.birthDate
            ? formatDateTime(patientData?.birthDate)
            : "-",
          gender: patientData?.gender
            ? GENDER_RECORD[patientData?.gender]
            : "-",
        };
      })()
    : null;

  useEffect(() => {
    if (transformedOrderData) {
      setTimeout(() => {
        pdfRef.current?.generatePdf();
      }, 1000);
    }
  }, [transformedOrderData]);
  return disclosureHost?.opened ? (
    <ReportViewer
      pdfRef={pdfRef}
      loading={isLoadingOrderData}
      onClose={() => {
        disclosureHost?.close();
      }}
      title={"Lab Order Report"}
    >
      {transformedOrderData && <OrderTemplate data={transformedOrderData} />}
    </ReportViewer>
  ) : null;
};

export default PrintOrders;
